import { Component, OnInit, inject, signal } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { LoadingService } from 'src/app/services/loading-service.service';
import { LegalService } from 'src/app/services/openapi/api/api';

@Component({
  selector: 'app-legal-notice',
  imports: [],
  templateUrl: './legal-notice.component.html',
  styleUrl: './legal-notice.component.scss',
})
export class LegalNoticeComponent implements OnInit {
  private readonly activatedRoute: ActivatedRoute = inject(ActivatedRoute);
  private readonly loadingService: LoadingService = inject(LoadingService);
  private readonly legalService: LegalService = inject(LegalService);
  title = signal('');
  legalHtmlNoticeContent = signal<SafeHtml>('');

  ngOnInit() {
    this.loadingService.loadingOn();
    this.activatedRoute.data.subscribe((data) => {
      this.title.set(data['title']);
      const noticeType: 'TermsOfUse' | 'PrivacyPolicy' | 'Accessibility' = data['legalNoticeType'];
      this.legalService.getLegalNotice(noticeType).subscribe({
        next: (result) => {
          this.legalHtmlNoticeContent.set(result);
        },
        complete: () => {
          this.loadingService.loadingOff();
        },
      });
    });
  }
}
